import axios from '@/lib/axios'
import type { OrganizationId } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { SalesDemoShowQueryKey } from './sales-demos.query'
import type {
  SalesDemoLifecycleResult,
  SalesDemoLoginCredentialsResult,
  SalesDemoState,
} from './sales-demos.types'

export async function getSalesDemo({
  queryKey: [{ organizationId }],
}: Pick<QueryFunctionContext<SalesDemoShowQueryKey>, 'queryKey'>) {
  return axios<SalesDemoState>(`/organizations/${organizationId}/sales-demo`)
}

export async function createSalesDemo(organizationId: OrganizationId) {
  return axios.post<SalesDemoLifecycleResult>(`/organizations/${organizationId}/sales-demo`)
}

export async function retrySalesDemo(organizationId: OrganizationId) {
  return axios.post<SalesDemoLifecycleResult>(`/organizations/${organizationId}/sales-demo/retry`)
}

export async function generateSalesDemoLoginCredentials(organizationId: OrganizationId) {
  return axios.post<SalesDemoLoginCredentialsResult>(
    `/organizations/${organizationId}/sales-demo/login-credentials`
  )
}

export async function extendSalesDemo(organizationId: OrganizationId) {
  return axios.post<SalesDemoLifecycleResult>(`/organizations/${organizationId}/sales-demo/extend`)
}

export async function deactivateSalesDemo(organizationId: OrganizationId) {
  return axios.post<SalesDemoLifecycleResult>(
    `/organizations/${organizationId}/sales-demo/deactivate`
  )
}

export async function reactivateSalesDemo(organizationId: OrganizationId) {
  return axios.post<SalesDemoLifecycleResult>(
    `/organizations/${organizationId}/sales-demo/reactivate`
  )
}
